var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0016 56.875C29.4016 56.875 28.8016 56.8001 28.2266 56.6251C15.2516 53.0501 5.85156 40.925 5.85156 27.775V16.7999C5.85156 13.9999 7.87658 10.9751 10.4766 9.90007L24.4016 4.2C28.0266 2.725 32.0015 2.725 35.6015 4.2L49.5266 9.90007C52.1266 10.9751 54.1516 13.9999 54.1516 16.7999V27.775C54.1516 40.9 44.7266 53.0251 31.7766 56.6251C31.2016 56.8001 30.6016 56.875 30.0016 56.875ZM30.0016 6.87502C28.5766 6.87502 27.1765 7.15006 25.8265 7.70006L11.9016 13.4C10.7016 13.9 9.60156 15.525 9.60156 16.825V27.8C9.60156 39.275 17.8516 49.8751 29.2266 53.0251C29.7266 53.1751 30.2766 53.1751 30.7766 53.0251C42.1516 49.8751 50.4016 39.275 50.4016 27.8V16.825C50.4016 15.525 49.3015 13.9 48.1015 13.4L34.1766 7.70006C32.8266 7.15006 31.4266 6.87502 30.0016 6.87502Z",
    fill: "#026C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.002 33.1249C26.202 33.1249 23.127 30.0499 23.127 26.2499C23.127 22.4499 26.202 19.3749 30.002 19.3749C33.802 19.3749 36.877 22.4499 36.877 26.2499C36.877 30.0499 33.802 33.1249 30.002 33.1249ZM30.002 23.1249C28.277 23.1249 26.877 24.5249 26.877 26.2499C26.877 27.9749 28.277 29.3749 30.002 29.3749C31.727 29.3749 33.127 27.9749 33.127 26.2499C33.127 24.5249 31.727 23.1249 30.002 23.1249Z",
    fill: "#026C96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.002 40.6249C28.977 40.6249 28.127 39.7749 28.127 38.7499V31.2499C28.127 30.2249 28.977 29.3749 30.002 29.3749C31.027 29.3749 31.877 30.2249 31.877 31.2499V38.7499C31.877 39.7749 31.027 40.6249 30.002 40.6249Z",
    fill: "#026C96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.ca089057d39358c303655a838108e125.svg";
export { ForwardRef as ReactComponent };